import { ContactService } from './../services/contact.service';
import { AppStateProvider } from './../services/app-state.provider';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  contactNumber;
  emailId;
  buildingName;
  areaName;
  cityName;
  pin;
  meetingNav: { index: string; name: string; link: string }[];
  // unamePattern = '^(?=.*[a-zA-Z]+.*)(?=.*[0-9]).{0,30}$';
  contactForm = new FormGroup({
    mobilenumber: new FormControl('', [
      Validators.required,
      Validators.pattern('[6-9]\\d{9}'),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+.[a-zA-Z]{2,4}$'),
    ]),
    building: new FormControl('', [
      Validators.required,
      Validators.minLength(4),
    ]),
    area: new FormControl('', [Validators.required, Validators.minLength(4)]),
    city: new FormControl('', [Validators.required, Validators.minLength(4)]),
    pincode: new FormControl(null, [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
      Validators.pattern('^[0-9]*$'),
    ]),
  });
  showResult: boolean;
  fieldErrors: any[] = [];
  constructor(
    private apiService: ContactService,
    private appStateSrv: AppStateProvider
  ) { }

  ngOnInit(): void {
    this.getDetail();
    this.meetingNav = [
      {
        index: '6',
        name: 'Contact',
        link: '/contact',
      },
    ];

    const route = {
      index: '6',
      name: 'Contact',
      link: '/contact',
    };
    this.appStateSrv.setSideNavState(route);
  }

  saveContact() {
    const formStatus = this.formValidator();
    if (!formStatus.valid) {
      this.fieldErrors = formStatus.errFields;
      window.scrollTo(0, 0);
      return;
    }
    this.fieldErrors = [];

    const data = {
      contactNumber: '+91' + this.contactNumber,
      emailId: this.emailId,
      buildingName: this.buildingName,
      area: this.areaName,
      city: this.cityName,
      pincode: this.pin,
      LocationId: localStorage.getItem("locationId") ?? 1,
    };
    this.apiService.updateContact(data).subscribe(
      (res) => {
        this.showResult = true;
      },
      (error) => { }
    );
  }

  getDetail() {
    this.apiService.getContact().subscribe((res) => {
      if (res.data == null) return (this.showResult = false);

      this.contactNumber = res.data.contactNumber.includes('+') ? res.data.contactNumber.slice(3) : res.data.contactNumber;
      this.emailId = res.data.emailId;
      this.buildingName = res.data.buildingName;
      this.areaName = res.data.area;
      this.cityName = res.data.city;
      this.pin = res.data.pincode;
      this.showResult = true;
    });
  }

  edit() {
    this.showResult = false;
    const formStatus = this.formValidator();
    if (!formStatus.valid) {
      this.fieldErrors = formStatus.errFields;
      window.scrollTo(0, 0);
      return;
    }
    this.fieldErrors = [];
  }

  cancel() {
    if (this.showResult) this.contactForm.reset();
    this.getDetail();
  }

  // validateNumber(event, maxLength: number, type) {
  //   if (type == 'pin' && this.pin.length > 5) event.preventDefault();
  //   if (type == 'mob' && this.contactNumber.length > 10) event.preventDefault();
  // }

  formValidator(type: string = 'add'): { valid: boolean; errFields: any } {
    const validate = (mobilenumber, email, building, pincode, area, city) => {
      let errFields = [];

      if (!mobilenumber || !/^\d{10}$/.test(mobilenumber)) {
        const i = errFields.indexOf('phone');
        if (i > -1) errFields.splice(i, 1);
        errFields.push('phone');
      } else {
        const i = errFields.indexOf('phone');
        if (i > -1) errFields.splice(i, 1);
      }
      if (
        !email ||
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+.[a-zA-Z]{2,4}$/.test(email)
      ) {
        const i = errFields.indexOf('emailID');
        if (i > -1) errFields.splice(i, 1);
        errFields.push('emailID');
      } else {
        const i = errFields.indexOf('emailID');
        if (i > -1) errFields.splice(i, 1);
      }

      if (!building) {
        const i = errFields.indexOf('building');
        if (i > -1) errFields.splice(i, 1);
        errFields.push('building');
      } else {
        const i = errFields.indexOf('building');
        if (i > -1) errFields.splice(i, 1);
      }

      if (!area) {
        const i = errFields.indexOf('area');
        if (i > -1) errFields.splice(i, 1);
        errFields.push('area');
      } else {
        const i = errFields.indexOf('area');
        if (i > -1) errFields.splice(i, 1);
      }

      if (!city) {
        const i = errFields.indexOf('city');
        if (i > -1) errFields.splice(i, 1);
        errFields.push('city');
      } else {
        const i = errFields.indexOf('city');
        if (i > -1) errFields.splice(i, 1);
      }
      if (!pincode || !/^[0-9]*$/.test(pincode)) {
        const i = errFields.indexOf('pincode');
        if (i > -1) errFields.splice(i, 1);
        errFields.push('pincode');
      } else {
        const i = errFields.indexOf('pincode');
        if (i > -1) errFields.splice(i, 1);
      }

      if (errFields.length > 0) return { valid: false, errFields: errFields };
      else return { valid: true, errFields: [] };
    };

    return validate(
      this.contactNumber,
      this.emailId,
      this.buildingName,
      this.pin,
      this.areaName,
      this.cityName
    );
  }
}
